// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g7ImTTZWW1kd7CC9kffZ{flex-grow:1;padding:0 16px;display:flex;position:relative}.s5fvR2ZeYoVZrlSZ9nTg{align-items:center;gap:10px;width:100%;min-width:0;display:flex}.s5fvR2ZeYoVZrlSZ9nTg :has(.Sv2uqnnWM9wftX7DGbhB){min-width:0}.Sv2uqnnWM9wftX7DGbhB{min-width:0}.TdmTpCC7sUcgkw_ht28B{flex:none;margin-left:auto;margin-right:8px}.x6vn_1RBUR01unS4EmSk{flex-direction:column;flex-grow:1;justify-content:center;align-items:center;gap:32px;display:flex}.x5Wy_dP_Xog1S8KYZska{background:linear-gradient(#f6f7f8 0%,#e9ebec 100%);border-radius:8px;overflow:hidden}.x5Wy_dP_Xog1S8KYZska img{display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `g7ImTTZWW1kd7CC9kffZ`,
	"nameCellWrapper": `s5fvR2ZeYoVZrlSZ9nTg`,
	"nameText": `Sv2uqnnWM9wftX7DGbhB`,
	"nameToggle": `TdmTpCC7sUcgkw_ht28B`,
	"empty": `x6vn_1RBUR01unS4EmSk`,
	"emptyPreview": `x5Wy_dP_Xog1S8KYZska`
};
export default ___CSS_LOADER_EXPORT___;
